import { useCallback } from 'react';
import { handleTooltipNode } from '../guardController';

/**
 * Возвращает callback-ref для DOM-узла пузыря тултипа.
 *
 * Показать тултип может только детектор — гард умеет лишь прятать.
 */
export function useTooltipObstructionGuard() {
    return useCallback((node: HTMLDivElement | null) => handleTooltipNode(node), []);
}
